<template>
  <div class="change-password" :class="{changePassword: $route.name == 'changePassword' || $route.name == 'EntranceFromEmail'}">
    <div class="out-message" v-if="$route.name == 'changePassword' || $route.name == 'EntranceFromEmail'">
      {{ $translate(codeText) }}
    </div>
    <div class="addNewForm">
      <el-form :model="ruleForm" status-icon="" :rules="rules" ref="changePasswordForm" :label-width="$store.state.language == 'en' ? '230px' : '100px'">
        <!-- <div class="subfield-blue-border"> -->
        <el-form-item :label="$translate('oldPassword')" prop="oldPassword">
          <el-input type="password" v-model.trim="ruleForm.oldPassword" :placeholder="$translate('oldPasswordTips')"></el-input>
        </el-form-item>
        <el-form-item :label="$translate('newPassword')" prop="password">
          <el-input type="password" :placeholder="$store.state.passwordPolicy == 2? $translate('intermePassword') : $store.state.passwordPolicy == 3 ? $translate('strengthPassword') : $translate('newPasswordTips')" v-model.trim="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item :label="$translate('confirmNewPassword')" prop="confirmPassword">
          <el-input type="password" :placeholder="$translate('confirmNewPassword')" v-model.trim="ruleForm.confirmPassword"></el-input>
        </el-form-item>
        <!-- </div> -->
        <el-form-item>
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="$store.state.loading" @click="submitForm">
            {{ $translate('save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { ChangePassword, ChangePwdByEmail } from "@/api/login";
import { baseUrl } from "@/config/env";
import { encrypt } from "../../../utils/encrypt";

export default {
  name: 'ChangePassword',
  props: ["setChangePasswordVisibile"],
  data() {
    let validatePass = (rule, value, callback) => {
      // 密码的验证规则 根据密码策略设置，如果type = 1 不限制长度和内容
      //type = 2 则限制密码长度在10~20之间
      //type = 3 则限制密码长度在10~20之间 必须包含数字，字母，特殊字符
      if (value == '') {
        callback(new Error(this.$translate('newPasswordTips')));
      } else {
        if (this.$store.state.passwordPolicy !== 1) {
          if (value.length > 20 || value.length < 10) {
            callback(new Error(this.$translate('newPasswordLengthRangeError')));
          } else {
            callback();
          }
          if (this.$store.state.passwordPolicy == 3) {
            let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{10,20}$/;
            if (!reg.test(value)) {
              callback(new Error(this.$translate('newPasswordContainError')));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      }
    }
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$translate('newPasswordConfirmTips')));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$translate('inputPasswordNoSame')));
      } else {
        callback();
      }
    }
    return {
      ruleForm: {
        "oldPassword": "",
        "password": "",
        "confirmPassword": ""
      },
      rules: {

        oldPassword: [{ required: true, message: this.$translate('oldPasswordTips'), trigger: 'blur' }],

        password: [{ required: true, validator: validatePass, trigger: 'blur' }],

        confirmPassword: [{ required: true, validator: validateConfirmPass, trigger: 'blur' }]
      }
    }
  },
  computed: {
    codeText() {
      let code = this.$route.params.changeCode;
      if (code || code == 0) {
        if (code == 1) {
          return 'resetPassword'
        }
        if (code == 2) {
          return 'strengthResetPassword'
        }
        if (code == 3) {
          return 'hasChangeResetPassword'
        }
      } else {
        if (this.$route.name == 'EntranceFromEmail') {
          return 'hasChangeResetPassword'
        }
      }
      return code
    }
  },
  mounted() {
    if (this.$route.query.token) {
      this.$store.commit("setNoLocalStorageLogin", { token: this.$route.query.token });
    }
  },
  methods: {
    changeSuccess() {
      this.$message({
        type: 'success',
        message: this.$translate('goToLogin'),
        onClose: () => {
          // 如果是邮件发送的链接进入的页面，全部统一在修改完密码之后返回到client的登录
          let type = this.$route.query.type || this.$route.query.loginmode;


          const url = this.$getOrigin();
          const {appName, adminName} = this.$store.state
          if (this.$route.name == 'EntranceFromEmail') {
            location.href = `${url}/${appName}/#/login"`;
          } else {
            let returnUrl = localStorage.getItem("returnUrl");
            let isssoout = localStorage.getItem("isssoout");
            // this.$store.commit(types.LOGOUT);

            //刷新页面为了避免缓存参数丢失
            if (isssoout && isssoout == 'true') {
              window.location.href = baseUrl + '/portalbasicapi/sso/LoginOut'
            } else if (returnUrl) {

              returnUrl = decodeURI(returnUrl);
              window.location.href = returnUrl;

            } else {

              let originName = `/${appName}/#/login`

              if (type == 'admin') {
                originName = `/${adminName}/#/`
              }

              if (type == 'mobile') {
                originName = "/mobile/#/login"
              }

              location.href = url + originName;
            }
          }
        }
      })
    },
    submitForm() {
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {
          /**
           * 修改密码有
           * 1. 主动修改，
           * 2. 系统配置更改密码模式为自定义模式邮件通知进来的修改
           * 3. 登录完成后密码状态需要修改的跳转
           * 
           * 如果是邮箱跳转的不需要登录，且免token验证，直接调用query的code
           */
          if (this.$route.query && this.$route.query.code) {
            /**
             * 
             */
            let code = this.$route.query.code;
            if (!code) {
              this.statusMsg(this.$translate('notGetCode'), "warning");
              return
            }
            let params = {
              "oldPassword": encrypt(this.ruleForm.oldPassword),
              "password": encrypt(this.ruleForm.password),
              "confirmPassword": encrypt(this.ruleForm.confirmPassword),
              code: code
            }

            ChangePwdByEmail(params).then(res => {
              if (res && res.isSuccess) {
                if (res.data.isSuccess) {
                  this.changeSuccess()
                } else {
                  this.$message({
                    type: 'error',
                    showClose: true,
                    message: res.data.message || 'loading error'
                  })
                }
              }
            })
          } else {
            let params = {
              "oldPassword": encrypt(this.ruleForm.oldPassword),
              "password": encrypt(this.ruleForm.password),
              "confirmPassword": encrypt(this.ruleForm.confirmPassword)
            }
            ChangePassword(params).then(res => {
              if (res && res.isSuccess) {
                if (res.data.isSuccess) {
                  this.changeSuccess()
                } else {
                  this.$message({
                    type: 'error',
                    showClose: true,
                    message: res.data.message
                  })
                }
              }
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.change-password {
  height: 100%;
  background-color: #fff;
  .out-message {
    color: red;
    margin-bottom: 15px;
    text-align: center;
  }
  &.changePassword {
    padding-top: 5%;
    .addNewForm {
      padding: 0 20%;
    }
  }
  .addNewForm {
    padding: 0 10%;
  }
}
</style>
